import React from "react";

const ServerAlert = ({ error }) => {
  if (!error) {
    return <></>;
  }

  return (
    <div
      class="alert alert-danger text-center font-weight-light text-uppercase"
      role="alert"
    >
      {error}
    </div>
  );
};

export default ServerAlert;
